module.exports = __webpack_public_path__ + "img/Headset Icon - charcoal.1f9114f6.svg";